import axios from 'axios'
import { CONFIG } from '@/config/config.js'

const socialApi = axios.create({
  baseURL: `${CONFIG.URL_SOCIAL_API_V2}/v2/misc`
})

export function getHomeConfig () {
  return socialApi.get('/home-config/')
}

export function listClientes (modulo) {
  return getHomeConfig().then(response => ({
    ...response,
    data: (response.data.clientes || []).filter(cliente => cliente.modulo === modulo)
  }))
}

export default socialApi
